import React, { ChangeEvent, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TURNOVER } from '~/actions/actionTypes';
import { setMissingError } from '~/actions/errorActions';
import { setInput } from '~/actions/formActions';
import { getMonthlyTurnoverOptions } from '~/services/DefaultLabelNameService';
import { IState } from '~/sharedInterfaces/IState';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import { IBaseInput } from '../../sharedInterfaces/SharedInterfaces';
import DropDown from '../Base/DropDown/DropDown';

export interface ITurnover extends IBaseInput {}

export interface ITurnoverProps extends IBaseComponent, ITurnover {}

const Turnover: FC<ITurnoverProps> = (props) => {
  const dispatch = useDispatch();

  const value = useSelector((state: IState) => state.signup.turnover || '');
  const error = useSelector((state: IState) => state.error.turnover);

  const { locale } = useSelector((state: IState) => state.widgetContext);
  const { turnoverValues } = getMonthlyTurnoverOptions(locale);

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const inputValue = event.target.value;
    dispatch(setInput(TURNOVER, inputValue));
    if (error) dispatch(setMissingError(TURNOVER, ''));
  };

  return (
    <DropDown
      {...props}
      tooltip
      value={value}
      dropDownValues={turnoverValues}
      onChange={handleOnChange}
      analyticsEvent="turnover"
      error={error?.missing}
    />
  );
};

export default Turnover;
